module.exports = __webpack_public_path__ + "img/ZE.07b28f74.jpg";